module.exports = __webpack_public_path__ + "static/img/5.efd707e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/5.png
// module id = mJ/e
// module chunks = 0